export default __webpack_public_path__ + "static/media/icon-home.4b8db8c1.svg";